import React from 'react';
import useHorizontalScroll from './useHorizontalScroll';
import './DesktopHorizontalScroll.css';

const DesktopHorizontalScroll = ({
  trackClassName = '',
  className = '',
  padding = '20px',
  trackStyle = undefined,
  trackProps = {},
  children
}) => {
  const {
    scrollRef,
    trackRef,
    thumbRef,
    hasOverflow,
    isDragging,
    onClickCapture,
    onTrackPointerDown,
    onThumbPointerDown
  } = useHorizontalScroll();

  return (
    <div className={`loopino-h-scroll ${className}`.trim()} style={{ '--loopino-h-scroll-pad': padding }}>
      <div
        className={`loopino-h-scroll-track ${trackClassName} ${isDragging ? 'is-dragging' : ''}`.trim()}
        ref={scrollRef}
        data-dragging={isDragging || undefined}
        onClickCapture={onClickCapture}
        style={trackStyle}
        {...trackProps}
      >
        {children}
      </div>
      <div
        className={`loopino-h-scrollbar${hasOverflow ? '' : ' is-hidden'}`}
        ref={trackRef}
        onPointerDown={onTrackPointerDown}
        aria-hidden="true"
      >
        <div
          className="loopino-h-scrollbar-thumb"
          ref={thumbRef}
          onPointerDown={onThumbPointerDown}
        />
      </div>
    </div>
  );
};

export default DesktopHorizontalScroll;
